import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { RealPropertyModel } from '../../../../../../../../typings/api/skymap/rest/v1/project';
import EmptyStatePurchases from '../../../../../../../static/empty_state_purchases.svg?react';
import { useDialog } from '../../../../../hooks/use-dialog';
import { Icon } from '../../../../icon/icon';
import { IconPanel } from '../../../../icon-panel/icon-panel';
import { CollapsableSection } from '../../../../skyview/right-menu/components/collapsable-section';
import { Stack } from '../../../../stack/stack';
import { RealPropertyCard } from '../real-property-card';
import { ExportRealPropertyDialog } from './export-real-property-dialog';

export const PurchaseHistorySection = (props: { items: RealPropertyModel[] }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const [selectedItem, setSelectedItem] = useState(props.items[0]);
  const dialog = useDialog();

  return (
    <CollapsableSection
      expanded={expanded}
      title={t('onDemand.purchaseHistory.title', { ns: 'components' })}
      titleUpperCase={true}
      onSetExpanded={setExpanded}
    >
      {props.items.length === 0 && (
        <IconPanel header={<EmptyStatePurchases />} responsiveness={{ compressed: false }}>
          {{
            title: t('onDemand.purchaseHistory.emptyStateTitle', { ns: 'components' }),
            info: t('onDemand.purchaseHistory.emptyStateInfo', { ns: 'components' }),
          }}
        </IconPanel>
      )}

      {props.items.length > 0 && (
        <OverflowY>
          <Stack spacing={0.4}>
            {props.items.map((item) => {
              return (
                <RealPropertyCard disabled={false} item={item} key={item.externalId}>
                  <Icon
                    disabled={false}
                    icon={['fal', 'cloud-download']}
                    title={t('onDemand.dialogs.export.title', { ns: 'components' })}
                    onClick={() => {
                      setSelectedItem(item);
                      dialog.show();
                    }}
                    onHoverStyle={{ icon: ['fad', 'cloud-download'] }}
                  />
                </RealPropertyCard>
              );
            })}
          </Stack>
        </OverflowY>
      )}

      {dialog.render(
        <ExportRealPropertyDialog item={selectedItem} onClose={() => dialog.hide()} />,
      )}
    </CollapsableSection>
  );
};

const OverflowY = styled.div`
  overflow-y: auto;
  max-height: 500px;
`;
